export default "__VITE_ASSET__ChXj9fhr__"